import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"flat":""}},[_c(VContainer,{attrs:{"fluid":"","loading":_vm.loading}},[_c(VRow,[_c(VCol,{attrs:{"xl":"3","lg":"3","md":"6","sm":"6","xs":"12"}},[_vm._t("search")],2),_c(VCol,{attrs:{"xl":"9","lg":"9","md":"6","sm":"6","xs":"12"}},[_vm._t("actions")],2)],1)],1),_c(VDivider),_c(VContainer,{attrs:{"fluid":"","loading":_vm.loading}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_vm._t("table")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }